module.exports = __webpack_public_path__ + "img/calendar.3f197093.svg";